import {
  Component,
  Input,
  OnChanges,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Display } from 'src/app/api/services/display';

@Component({
  selector: 'edit-screen-sharing',
  templateUrl: './edit-screen-sharing.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  styleUrls: ['./edit-screen-sharing.component.scss'],
  standalone: false,
})
export class EditScreenSharingComponent implements OnInit, OnChanges {
  @Input() model: ScreenSharingModel = {
    settings: {},
  };
  @Input() licenseRequired: TemplateRef<any>;
  @Input() isLicenseRequired: boolean;

  bulkEditForm: NgForm;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit(): void {
    this.bulkEditForm = <NgForm>this.controlContainer;
  }

  ngOnChanges(): void {
    this.ensureScreenSharingPinRequiredIsBoolean();
    this.ensureScreenSharingAuthenticationRequiredIsBoolean();
    this.ensureScreenSharingCodeHiddenIsBoolean();
  }

  screenShareModeChange() {
    this.ensureScreenSharingPinRequiredIsBoolean();
    this.ensureScreenSharingAuthenticationRequiredIsBoolean();
    this.ensureScreenSharingCodeHiddenIsBoolean();
  }

  screenShareCodeHiddenChange(checked: boolean) {
    this.model.settings.screenSharingCodeHidden = !checked;
  }

  screenSharePinRequiredChange(screenSharingPinRequired: boolean) {
    if (
      screenSharingPinRequired &&
      this.model.settings.screenSharingAuthenticationRequired
    ) {
      this.model.settings.screenSharingAuthenticationRequired = false;
    }
  }

  screenShareAuthenticationRequiredChange(
    screenSharingAuthenticationRequired: boolean,
  ) {
    if (
      screenSharingAuthenticationRequired &&
      this.model.settings.screenSharingPinRequired
    ) {
      this.model.settings.screenSharingPinRequired = false;
    }
  }

  private ensureScreenSharingPinRequiredIsBoolean() {
    if (
      this.model.settings.screenSharingPinRequired &&
      typeof this.model.settings.screenSharingPinRequired === 'string'
    ) {
      this.model.settings.screenSharingPinRequired =
        this.model.settings.screenSharingPinRequired === 'true';
    }
  }

  private ensureScreenSharingAuthenticationRequiredIsBoolean() {
    if (
      this.model.settings.screenSharingAuthenticationRequired &&
      typeof this.model.settings.screenSharingAuthenticationRequired ===
        'string'
    ) {
      this.model.settings.screenSharingAuthenticationRequired =
        this.model.settings.screenSharingAuthenticationRequired === 'true';
    }
  }

  private ensureScreenSharingCodeHiddenIsBoolean() {
    if (
      this.model.settings.screenSharingCodeHidden &&
      typeof this.model.settings.screenSharingCodeHidden === 'string'
    ) {
      this.model.settings.screenSharingCodeHidden =
        this.model.settings.screenSharingCodeHidden === 'true';
    }
  }
}

type ScreenSharingModel = Pick<
  Display,
  'screenSharingEnabled' | 'settings' | 'isDisplayControlEnabled'
>;
